<template>
  <section class="app-aproc">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12>
          <v-card outlined class="app-card">
            <v-card-title class="app-card-title">
              Transportadora
              <v-btn
                depressed
                small
                color="error"
                v-on:click="logout()"
                class="btn-logout"
              >
                <v-icon>exit_to_app</v-icon>Sair
              </v-btn>
            </v-card-title>
            <v-card-text class="app-card-content">
              <v-row no-gutters v-if="transportadora">
                <v-col :md="12" :sm="12" :xs="12" cols="12">
                  <strong class="info-text">
                    Razão Social:
                    <em>{{ transportadora.razaosocial }}</em>
                  </strong>
                </v-col>
                <v-col
                  :md="12"
                  :sm="12"
                  :xs="12"
                  cols="12"
                  class="mt-2 text-md-left"
                >
                  <strong class="info-text">
                    CNPJ:
                    <em>{{ transportadora.cnpj | cnpj }}</em>
                  </strong>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card outlined class="app-card">
            <v-card-title class="app-card-title"
              >Certificado de Registro</v-card-title
            >
            <v-card-text class="app-card-content">
              <v-alert outlined type="info" text
                >Abaixo é possível gerar o certificado apenas clicando no
                botão.</v-alert
              >
              <br />
              <v-form
                ref="form"
                v-model="formModel.valid"
                lazy-validation
                @submit.prevent="onSubmit"
              >
                <v-row>
                  <v-col :md="3" :sm="3" :xs="3" cols="12" class="pt-0 pb-0">
                    <vue-recaptcha
                      ref="recaptcha"
                      :sitekey="siteKey"
                      :loadRecaptchaScript="true"
                      @verify="verifyRecaptcha"
                      @expired="expiredRecaptcha"
                      class="recaptcha pt-0 pb-0"
                    ></vue-recaptcha>
                    <v-input
                      v-model="formModel.recaptcha"
                      :rules="[rules.required]"
                      class="pt-0 pb-0"
                      style="margin-top: -25px;"
                    ></v-input>
                    <v-btn
                      depressed
                      block
                      large
                      color="primary"
                      type="submit"
                      class="pt-0 pb-0"
                      >Gerar Certificado</v-btn
                    >
                  </v-col>
                </v-row>
              </v-form>
              <div class="loading" v-if="isLoading">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  :size="20"
                  :width="2"
                ></v-progress-circular>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import { VUE_APP_RECAPTCHA_KEY } from "@/commons/config";
import { mask } from "vue-the-mask";
import TransportadoraAuthService from "@/services/transportadora.auth.service";
import ReportService from "@/services/report.service";

export default {
  components: {
    VueRecaptcha
  },
  directives: {
    mask
  },
  metaInfo: {
    title: "Certificado de Registro de Veículos - Central de Serviços"
  },
  data() {
    return {
      siteKey: VUE_APP_RECAPTCHA_KEY,
      isLoading: false,
      transportadora: null,
      formModel: {
        cnpj: null,
        token: null,
        recaptcha: null,
        numOrdem: null
      },
      valid: false,
      rules: {
        required: value => !!value || "Esse campo deve ser preenchido",
        pattern: value =>
          !!value.match(/^([0-9])*\/[0-9]{4}$/) ||
          "Esse campo está fora do padrão"
      }
    };
  },
  methods: {
    verifyRecaptcha(value) {
      this.formModel.recaptcha = value;
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.formModel.recaptcha = null;
    },
    onSubmit() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        const { cnpj, token, recaptcha, numOrdem } = this.formModel;
        this.isLoading = true;
        ReportService.certificadoRegistro(cnpj, recaptcha,numOrdem).subscribe(
          res => {
            const filename = `CertificadoRegistroVeiculo_${cnpj}.pdf`;
            this.download(res, filename);
            this.isLoading = false;
            this.expiredRecaptcha();
          },
          error => {
            this.expiredRecaptcha();
            this.isLoading = false;
          }
        );
      }
    },
    download: (res, filename) => {
      const file = new Blob([res], {
        type: "application/pdf",
        fileName: "CertificadoRegistroVeiculo"
      });
      const fileURL = URL.createObjectURL(file);
      let a = document.createElement("a");
      a.href = fileURL;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(fileURL);
    },
    logout() {
      TransportadoraAuthService.logout();
    },
    getCurrentTransportadora() {
      this.transportadora =
        TransportadoraAuthService.currentTransportadoraValue;

      this.formModel.cnpj = this.transportadora.cnpj;
      this.formModel.token = this.transportadora.token;
      this.formModel.numOrdem = this.transportadora.numOrdem;

    }
  },
  mounted() {
    this.getCurrentTransportadora();
  }
};
</script>

<style></style>
